/**
 * DevisView
 * Main container for devis (quotes) management
 */

import React from 'react';
import DevisListView from './DevisListView';

export const DevisView: React.FC = () => {
  return (
    <div className="h-full">
      <DevisListView />
    </div>
  );
};

export default DevisView;
